export const ORDER_FORM_SIGNATURE_STEP_INDEX = 4;

interface RequestedOrderStepOptions {
  urlInitialStep: string | null;
  stateInitialStep?: number;
  cachedTopStep?: number | null;
  ignoreZeroStateInitialStep?: boolean;
}

function toValidStep(step: string | number | null | undefined) {
  if (step === null || step === undefined || step === "") {
    return null;
  }

  const parsedStep = Number(step);
  return Number.isFinite(parsedStep) ? parsedStep : null;
}

export function getRequestedOrderStep({
  urlInitialStep,
  stateInitialStep,
  cachedTopStep,
  ignoreZeroStateInitialStep = false,
}: RequestedOrderStepOptions) {
  const normalizedStateInitialStep =
    ignoreZeroStateInitialStep && stateInitialStep === 0
      ? undefined
      : stateInitialStep;

  return (
    toValidStep(urlInitialStep) ??
    toValidStep(normalizedStateInitialStep) ??
    toValidStep(cachedTopStep)
  );
}

export function isSignatureStep(step: number) {
  return step === ORDER_FORM_SIGNATURE_STEP_INDEX;
}
